import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function recipeReducer(state = initialState.recipe, action) {
	switch(action.type) {
		case types.LOAD_RECIPE_SUCCESS:
			//debugger;
			return action.recipe;

		default:
			return state;
	}
}


/** WEBPACK FOOTER **
 ** ./src/reducers/recipeReducer.js
 **/